
import {Vue, Component} from 'vue-property-decorator';

import {userApi, accountApi, classesApi} from '@/api';
import formHelper from '../../../js/classes/classes.helper';
import Empty from '@/components/Empty/index.vue';
import Class_Authorize from './class_authorize.vue';
import Class_Teacher from './class_teacher.vue';

import moment from 'moment';
@Component({
    components: {
        Empty,
        Class_Authorize,
        Class_Teacher
    }
})
export default class Class_Authorize_Book extends Vue {
    //===================================data区域begin
    schoolId: any = '';
    classId: any = '';
    className: any = '';
    // 关联课程列表
    columns: any = formHelper.authorizeColumns;
    pager: any = {
        default: {
            pagesize: 10,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };
    query: any = {
        name: ''
    };

    loading: boolean = false;
    visibleTeacher: boolean = false;
    // 关联课程模态框显隐
    showClassAuthorize: boolean = false;
    // 添加教师信息
    teacherList: any = [];

    //===================================data区域end
    //===================================computed区域begin
    //===================================computed区域end

    //===================================methods区域begin
    // 鼠标移入表格
    customRow(record: any) {
        return {
            on: {
                mouseenter: (record: any) => {
                    const row = record.srcElement.children;
                    // if (row[2].innerText == '暂无') {
                    // console.log(Number(row[0].innerText) % 10);
                    (document.querySelectorAll('.add')[(Number(row[0].innerText) - 1) % 10] as any).style.display = 'inline';
                    // }
                },
                mouseleave: (record: any) => {
                    const row = record.srcElement.children;
                    (document.querySelectorAll('.add')[(Number(row[0].innerText) - 1) % 10] as any).style.display = 'none';
                },
                click: (record: any) => {
                    // const row = record.srcElement.parentElement.parentElement.parentElement.parentElement.children;
                    // this.addTeacherBtn = false;
                }
            }
        };
    }

    searchCourse(value: any) {
        this.query.name = value;
        this.getList();
    }
    // 关联课程
    authorizeCourse() {
        // console.log(this);
        this.showClassAuthorize = true;
    }
    deleteTeacher(record: any) {
        let me = this;
        // console.log(record);
        let data = {
            classId: record.classId,
            courseId: record.courseId,
            teacherId: record.teachers[0].teacherId
        };
        me.$confirm({
            title: '提示',
            content: '取消教师会取消与该班级该门课程的关联，请谨慎操作。',
            onOk() {
                classesApi.deleteTeacherInClass({
                    context: me,
                    data: data,
                    success(data: any, parameters: any) {
                        me.pager.default.rows = [];
                        me.$message.success('操作成功！该教师已取消关联。');
                        me.getList();
                    },
                    error(error: any, message: string, parameters: any) {
                        me.$message.error('操作失败！该教师正在上课中，暂时无法取消关联。');
                    }
                });
            },
            onCancel() {}
        });
    }
    // 关联教师
    addTeacher(record: any) {
        this.teacherList = [];
        this.teacherList.push(record);
        this.visibleTeacher = true;
    }
    // 关联课程后关联教师
    openTeacher(val: any) {
        // console.log(val);
        if (val) {
            this.teacherList = val;
            setTimeout(() => {
                this.visibleTeacher = true;
            }, 1000);
        }
    }
    paginationChange(page: number, pageSize: number) {
        this.pager.default.pagenum = page;
        this.getList();
    }

    // 取消关联
    handleDeleteCourse(record: any) {
        let me = this;
        me.$confirm({
            title: '提示',
            content: '取消关联会同时取消与该班级及教师的关联，请谨慎操作。',
            onOk() {
                classesApi.cancelAuthorization({
                    context: me,
                    urlParamObj: {
                        id: record._id
                    },
                    success(data: any, parameters: any) {
                        me.$message.success('操作成功！该课程已取消关联。');
                        me.getList();
                    },
                    error(error: any, message: string, parameters: any) {
                        me.$message.error('操作失败！该课程正在上课中，暂时无法取消关联。');
                    }
                });
            },
            onCancel() {}
        });
    }
    refreshCourseList() {
        this.pager.default.pagenum = 1;
        this.getList();
    }
    getList() {
        let me = this;
        me.loading = true;
        let urlQueryParmas = {
            classId: me.classId,
            courseName: me.query.name
        };
        classesApi.getCourseListByClassId({
            context: me,
            pager: me.pager.default,
            urlQueryParmas: urlQueryParmas,
            appendAttributes: [
                {
                    key: 'teacherName',
                    value: ''
                }
            ],
            afterRender(data: any) {
                me.loading = false;
                return data;
            }
        });
    }
    //===================================methods区域end
    created() {
        if (this.$route.query) {
            this.classId = this.$route.query.classId;
            this.className = this.$route.query.className;
        }
        let state = this.$app.getState();
        this.schoolId = state.schoolId;
        this.getList();
        // console.log(this);
    }
}
